import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`avaliacoes/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`avaliacoes/adm/${id}`);
    },
    create(data) {
        return Api().post(`avaliacoes`, data);
    },
    update(data) {
        return Api().put(`avaliacoes/${data.id}`, data);
    },
    getQuestoes(id) {
        return Api().get(`avaliacoes/${id}/questoes`);
    },
    saveQuestoes(id, questoes) {
        return Api().post(`avaliacoes/${id}/questoes`, { questoes });
    },
    getResultados(id) {
        return Api().get(`avaliacoes/${id}/resultados`);
    },
    getDetalhesResposta(avaliacaoId, tentativa, userId) {
        return Api().get(`avaliacoes/${avaliacaoId}/respostas/${tentativa}?userId=${userId}`);
    }
}